import { adobeAnalyticsScriptsSelector } from '@doda/common/src/redux/features/analytics';
import { AppThunk } from '@doda/common/src/redux/store';
import { tlReadyExecute } from '@doda/common/src/utils/adobeAnalyticsUtil';

/**
 * キーワードの計測処理
 * @returns 計測処理
 */
export const measureKeywordSearch =
  (): AppThunk<void> => (dispatch, getState) => {
    const isAdobeScript = adobeAnalyticsScriptsSelector(getState());
    tlReadyExecute(isAdobeScript, dispatch, 'FW_SRCHsgt_imp', {});
  };
